import { render, staticRenderFns } from "./AttributeGroupPage.vue?vue&type=template&id=06e79122"
import script from "./AttributeGroupPage.vue?vue&type=script&lang=js"
export * from "./AttributeGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports